import * as React from 'react';

import type {
    GetQuoteById_quote as Quote,
    GetInvoiceById_invoice as Invoice,
} from 'nutshell-graphql-types';

import {PEANUT_TARGET} from '../../consts';
import {previewQuote} from '../../helpers';

export function useRenderPeanut(
    instanceId?: string | null,
    quote?: Quote | Invoice | null,
    peanutTarget?: HTMLElement | null
) {
    React.useEffect(() => {
        if (peanutTarget && instanceId && quote) {
            // Don't attempt to render a removed sales document
            if (quote.displayStatus === 'ARCHIVED') {
                return;
            }
            previewQuote(instanceId, quote.slug, peanutTarget, PEANUT_TARGET);
        }
    }, [instanceId, quote, peanutTarget]);

    const rerender = React.useCallback(() => {
        if (peanutTarget && instanceId && quote) {
            // Don't attempt to render a removed sales document
            if (quote.displayStatus === 'ARCHIVED') {
                return;
            }
            previewQuote(instanceId, quote.slug, peanutTarget, PEANUT_TARGET);
        }
    }, [instanceId, quote, peanutTarget]);

    return {
        rerender,
    };
}
